<template>
    <div class="ur-data-grid__content__tooltip-anchor">
        <div class="ur-data-grid__content__freeze-tooltip-wrapper" :style="$parent.freezeStyle">
            <div class="ur-data-grid__content__freeze-tooltip-scroller" ref="freezeTooltip" :style="scrollerStyle">
                <t-item v-for="(item, idx) in gridInfo.vars_messages" :data="item" :key="item.key+'____'+item.row.__idx" 
                        v-if="item.field.__frz" :data-key="item.key+'____'+item.row.__idx"/>
            </div>
        </div>
        <div class="ur-data-grid__content__scroll-tooltip-wrapper" :style="$parent.scrollStyle">
            <div class="ur-data-grid__content__scroll-tooltip-scroller" ref="scrollTooltip" :style="scrollerStyle">
                <t-item v-for="(item, idx) in gridInfo.vars_messages" :data="item" :key="item.key+'____'+item.row.__idx" 
                        v-if="!item.field.__frz" :data-key="item.key+'____'+item.row.__idx"/>
            </div>
        </div>
    </div>
</template>

<script>
import tItem from './urDataGridContentTooltipItem'
export default {
    name : 'urDataGridContentTooltipAnchor',
    components : {tItem},
    inject : ['gridInfo'],
    props:{
        height:{type:Number, default:0}
    },
    computed: {
        scrollerStyle() {
            var style = {};
            if(this.height) style['height'] = this.height+"px";
            return style;
        }
    },
    mounted() {
        this.gridInfo.func.setRefs('freezeTooltip',this.$refs.freezeTooltip);
        this.gridInfo.func.setRefs('scrollTooltip',this.$refs.scrollTooltip);
    }
}
</script>